module.exports = __webpack_public_path__ + "static/media/buy-me-a-coffee-button.5ec87223.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/buy-me-a-coffee-button.svg
// module id = 27
// module chunks = 0